import { ThunkResult } from "../../shared/utilities";
import { IAction } from "../model/IAction";
import { ElementType, IElement } from "../model/IProcessData";
import { PanelType, ProcessSidePanelType, State } from "../model/State";

export const TestElementId = "FrendsTestElementId";

export const OPEN_PROCESS_SIDE_PANEL = "OPEN_PROCESS_SIDE_PANEL";
export function openProcessSidePanel(panelType: ProcessSidePanelType): IOpenSidePanelAction {
    return {
        type: OPEN_PROCESS_SIDE_PANEL,
        panelType: panelType
    };
}

export interface IOpenSidePanelAction extends IAction {
    panelType: ProcessSidePanelType;
}

export const CLOSE_PROCESS_SIDE_PANEL = "CLOSE_SIDE_PANEL";
export function closeProcessSidePanel(): IAction {
    return {
        type: CLOSE_PROCESS_SIDE_PANEL
    };
}

export function addOrSelectTestPanel(parameters?: {}, selectedTaskId?: string): ThunkResult<void, State> {
    return (dispatch, getState) => {
        if (selectedTaskId != null || getState().elements[TestElementId] == null) {
            dispatch(addTestProcess(parameters, selectedTaskId));
        }
        dispatch(openProcessSidePanel(ProcessSidePanelType.TestPanel));
    };
}

export const ADD_TEST_PROCESS = "ADD_TEST_PROCESS";
function addTestProcess(parameters?: {}, selectedTaskId?: string): IAddTestAction {
    return {
        type: ADD_TEST_PROCESS,
        element: { id: TestElementId, type: ElementType.TestTask, name: "Test", parameters: parameters || {}, selectedTypeId: selectedTaskId }
    };
}

export interface IAddTestAction extends IAction {
    element: IElement;
}

export const PIN_PROCESS_SIDE_PANEL = "PIN_PROCESS_SIDE_PANEL";
export function pinProcessSidePanel(): IAction {
    return {
        type: PIN_PROCESS_SIDE_PANEL
    };
}

export function closeElementPanel(): IAction {
    return { type: CLOSE_ELEMENT_PANEL };
}

export const CLOSE_ELEMENT_PANEL = "CLOSE_ELEMENT_PANEL";


export const TOGGLE_DOCUMENTATION_PANEL = "TOGGLE_DOCUMENTATION_PANEL";
export function toggleDocumentationPanel(): IAction {
    return { type: TOGGLE_DOCUMENTATION_PANEL };
}

export const CLOSE_DOCUMENTATION_PANEL = "CLOSE_DOCUMENTATION_PANEL";
export function closeDocumentationPanel(): IAction {
    return { type: CLOSE_DOCUMENTATION_PANEL };
}

export const TOGGLE_EDIT_TASK = "TOGGLE_EDIT_TASK";
export function toggleEditTask(show?: boolean): IToggleEditTaskAction {
    return {
        type: TOGGLE_EDIT_TASK,
        show: show ?? false
    };
}

export const UPDATE_PANEL_WIDTH = "UPDATE_PANEL_WIDTH";
export function updatePanelWidth(panelType: PanelType, width: number): IUpdatePanelWidthAction {
    return {
        type: UPDATE_PANEL_WIDTH,
        panelType: panelType,
        width: width
    };
}
export interface IUpdatePanelWidthAction extends IAction {
    panelType: PanelType;
    width: number;
}

export interface IToggleEditTaskAction extends IAction {
    show: boolean
}